var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.mode == "DESIGN"
      ? _c(
          "div",
          { staticClass: "phone-con" },
          [
            _c(
              "div",
              {
                class:
                  _vm.inputType == "both"
                    ? "head-text head-text-all"
                    : "head-text",
              },
              [_vm._v(_vm._s(_vm.headText))]
            ),
            _c("el-input", {
              staticClass: "disabled-box phone-input",
              attrs: {
                size: "small",
                placeholder: _vm.placeholder,
                maxlength: "20",
              },
            }),
          ],
          1
        )
      : !_vm.readerMode || _vm.perm === "E"
      ? _c(
          "div",
          { staticClass: "phone-con" },
          [
            _vm.inputType != "both"
              ? _c(
                  "div",
                  {
                    class: [
                      _vm.perm === "R"
                        ? "head-text head-text-disabled"
                        : "head-text",
                    ],
                  },
                  [_vm._v(_vm._s(_vm.headText))]
                )
              : _vm._e(),
            _c(
              "el-input",
              {
                staticClass: "phone-input",
                attrs: {
                  size: "small",
                  clearable: "",
                  placeholder: _vm.placeholder,
                  maxlength: "20",
                  disabled: _vm.perm === "R",
                },
                on: { input: _vm.change },
                model: {
                  value: _vm._value.value,
                  callback: function ($$v) {
                    _vm.$set(_vm._value, "value", $$v)
                  },
                  expression: "_value.value",
                },
              },
              [
                _vm.inputType == "both"
                  ? _c(
                      "el-select",
                      {
                        staticClass: "head-text-select",
                        attrs: {
                          slot: "prepend",
                          size: "small",
                          disabled: _vm.perm === "R",
                        },
                        on: { change: _vm.changeSelect },
                        slot: "prepend",
                        model: {
                          value: _vm.tempType,
                          callback: function ($$v) {
                            _vm.tempType = $$v
                          },
                          expression: "tempType",
                        },
                      },
                      [
                        _c("el-option", {
                          attrs: { label: "手机", value: "phone" },
                        }),
                        _c("el-option", {
                          attrs: { label: "固话", value: "tel" },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        )
      : _c(
          "div",
          { staticClass: "form-item-text" },
          [
            _vm._value.value
              ? [
                  _vm._v(
                    " " +
                      _vm._s(_vm.headTextDis) +
                      " " +
                      _vm._s(_vm._value.value) +
                      " "
                  ),
                ]
              : _vm._e(),
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }